
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fb5x", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $luv00 = parcelRequire("luv00");


var $6mKj3 = parcelRequire("6mKj3");


var $dA1Sn = parcelRequire("dA1Sn");





var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $e4o8D = parcelRequire("e4o8D");


var $jMyy4 = parcelRequire("jMyy4");





var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");




/**
 * @generated SignedSource<<8123d4d752ec36317e81af577d546915>>
 * @relayHash 81e92b7bef30c91df7d1d5fc36cdd372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72
const $6900e8f8fbd4b479$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "color"
    }, v4 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        }
                    ]
                },
                {
                    "condition": "isDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "format",
                                    "value": "USER_FRIENDLY"
                                }
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ],
                            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "81e92b7bef30c91df7d1d5fc36cdd372",
            "id": "8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72",
            "metadata": {},
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineWithContributorsComponentEditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$6900e8f8fbd4b479$var$node.hash = "cbad882df31b75e4699e60f1bcf2ae8b";
var $6900e8f8fbd4b479$export$2e2bcd8739ae039 = $6900e8f8fbd4b479$var$node;






var $T1bCI = parcelRequire("T1bCI");


var $gdv5Z = parcelRequire("gdv5Z");


var $laFNM = parcelRequire("laFNM");


var $63EIj = parcelRequire("63EIj");


var $jkVM2 = parcelRequire("jkVM2");


var $bJX6u = parcelRequire("bJX6u");


var $9wGTI = parcelRequire("9wGTI");


var $7om8k = parcelRequire("7om8k");


var $7QM6o = parcelRequire("7QM6o");





var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $4FHTF = parcelRequire("4FHTF");


var $3FlVr = parcelRequire("3FlVr");


var $83sfO = parcelRequire("83sfO");





var $1NF8X = parcelRequire("1NF8X");





var $5UrgY = parcelRequire("5UrgY");

const $06f66a283e23582e$var$i18n = (0, $aXWIB.defineMessages)({
    addNew: {
        id: "live-pages-features.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "live-pages-features.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $06f66a283e23582e$var$dotStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-050, 4px)",
    width: "var(--ds-space-050, 4px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'radius.full',
    alignSelf: 'center',
    transition: 'opacity 300ms ease-in-out'
});
const $06f66a283e23582e$var$floatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'left',
    transition: 'left 600ms',
    marginBottom: 'space.025',
    height: '28px',
    marginTop: 'space.025'
});
const $06f66a283e23582e$export$37ba4ba009bc421f = ({ contentId: contentId, spaceId: spaceId, isDisabled: isDisabled = false, contentType: contentType, isCurrentUserContributor: isCurrentUserContributor = false, editorBylineContainerRef: editorBylineContainerRef })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Used when we want to allow the user to select reactions from the summary view popup
    const customIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
        testId: "emoji-add-icon",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    });
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const { isEligible: isEligibleReactionsFeedbackPageReturn } = (0, $5UrgY.useIsEligibleReactionsFeedbackPageReturn)({
        contentId: contentId,
        isContributor: Boolean(isCurrentUserContributor),
        skip: !(0, $9wGTI.fg)('cc-engagement-reaction-feedback-page-return-kill'),
        source: 'livePage'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f66a283e23582e$var$floatingContainerStyles,
        testId: "live-pages-reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType === 'blogpost' ? (0, $3FlVr.ReactionLocation).BLOGPOST : (0, $3FlVr.ReactionLocation).PAGE,
        containerId: spaceId,
        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
        contentSubType: isLivePage ? (0, $83sfO.LIVE_PAGE_SUBTYPE) : null,
        summaryViewEnabled: true,
        summaryViewThreshold: 1,
        allowSelectFromSummaryView: true,
        useButtonAlignmentStyling: true,
        summaryViewPlacement: "bottom-start",
        readOnly: isDisabled,
        isViewOnly: isDisabled,
        isSubtle: true,
        reactionPickerTriggerIcon: customIcon,
        reactionPickerTriggerText: formatMessage($06f66a283e23582e$var$i18n.addNew),
        useDefaultStyledContainer: true,
        hidePlaceholder: isSSR,
        noRelativeContainer: true,
        noFlexWrap: true,
        hoverableSummaryView: true,
        optimisticallyLoadSummaryEmojis: isSSR,
        renderParticleEffectOnSummaryView: true,
        bylineContainerRef: editorBylineContainerRef,
        renderParticleEffectOnLoad: isEligibleReactionsFeedbackPageReturn
    }), isEligibleReactionsFeedbackPageReturn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f66a283e23582e$var$dotStyles,
        testId: "reactions-feedback-experiment-live-dot"
    }));
};



var $fImWv = parcelRequire("fImWv");


var $04VgG = parcelRequire("04VgG");





var $5vi32 = parcelRequire("5vi32");








var $a9SX7 = parcelRequire("a9SX7");


var $JTIzG = parcelRequire("JTIzG");


var $8h2Hn = parcelRequire("8h2Hn");


var $LSims = parcelRequire("LSims");








var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $6qdjm = parcelRequire("6qdjm");


var $3gadb = parcelRequire("3gadb");














var $bQm3c = parcelRequire("bQm3c");


var $AavAW = parcelRequire("AavAW");


var $9BupY = parcelRequire("9BupY");

const $dce34ae8b4376c02$var$i18n = (0, $aXWIB.defineMessages)({
    recentFriendlyWhen: {
        id: "content-header.by-line.live-pages.last.updated.friendly.just.now",
        defaultMessage: "Just now"
    },
    tooltipWhen: {
        id: "content-header.by-line.live-pages.last.updated.tooltip",
        defaultMessage: "Last updated: {day} at {time}"
    }
});
const $dce34ae8b4376c02$export$e4a26074619839f4 = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, editorApi: editorApi })=>{
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $9BupY.default), {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        // sets loading to true when refetching, necessary for tooltip
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network' // query is preloaded on SSR, but not for SPA
        ,
        __callerPackage__: "@confluence/content-header"
    });
    const latestVersion = data?.content?.nodes?.[0]?.version;
    // We need version in a state variable separate from query data, in order to set it on debouncedSetRecentVersion
    const [version, setVersion] = (0, $42omo.useState)({
        friendlyWhen: latestVersion?.friendlyWhen || null,
        when: latestVersion?.when || null
    });
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const intl = (0, $aXWIB.useIntl)();
    // Medium dateStyle does not support 'at' combiner, so we're using separate date/time formatters
    const dayFormatter = Intl.DateTimeFormat(locale, {
        dateStyle: 'medium'
    });
    const timeFormatter = Intl.DateTimeFormat(locale, {
        timeStyle: 'short'
    });
    (0, $42omo.useEffect)(()=>{
        // Only show the latest version, which could be from the query or from debouncedSetRecentVersion
        if (latestVersion && JSON.stringify(latestVersion) !== JSON.stringify(version) && latestVersion.when && latestVersion.when >= (version?.when ?? '0')) setVersion({
            friendlyWhen: latestVersion.friendlyWhen ?? null,
            when: latestVersion.when ?? null
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to trigger this on data change
    }, [
        latestVersion
    ]);
    // Fetch that is immediately invoked before the debounced wait period
    // Used on visibility change (when user switches to this tab) and mouseenter
    const debouncedLeadingFetch = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(refetch, 60000, {
            leading: true,
            trailing: false,
            maxWait: 60000
        }), [
        refetch
    ]);
    (0, $42omo.useEffect)(()=>{
        // Fetch last updated time when tab is focused
        const handleVisibilityChange = async ()=>{
            if (document.visibilityState === 'visible') debouncedLeadingFetch(); // Get latest value when user switches back to this tab
        };
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        debouncedLeadingFetch
    ]);
    // After a page edit, we know the last change was very recent, so we directly set the version and skip
    // fetching over the network. We still debounce this to avoid rapid calls and prevent perfromance lag
    // when a user starts typing on very large pages
    const debouncedSetRecentVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setVersion({
                friendlyWhen: intl.formatMessage($dce34ae8b4376c02$var$i18n.recentFriendlyWhen),
                when: new Date().toISOString()
            });
        }, 3000), [
        setVersion,
        intl
    ]);
    // Update time stamp to "Just now" on page edit
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    // Cancel any pending timers on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            debouncedLeadingFetch.cancel();
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedLeadingFetch,
        debouncedSetRecentVersion
    ]);
    const tooltipContent = (0, $42omo.useMemo)(()=>{
        if (loading) return null;
        else if (version?.when) {
            // When time since last update is > 48 hours ago, friendlyWhen will be a date (i.e. Oct 31, 2024)
            // However, user time zone conversion of the friendlyWhen date is not currently working on the BE,
            // which means the localized date in the tooltip can differ from the UTC date in the byline.
            // To fix this discrepancy, for now we'll not show the tooltip for dates > 48 hours
            const date = new Date(version?.when);
            const twoDaysInMillis = 172800000;
            if (Date.now() - date.getTime() > twoDaysInMillis) return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$dce34ae8b4376c02$var$i18n.tooltipWhen,
                values: {
                    day: dayFormatter.format(date),
                    time: timeFormatter.format(date)
                }
            });
        }
    }, [
        loading,
        version?.when,
        dayFormatter,
        timeFormatter
    ]);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
        // so returning empty `<ErrorDisplay>` here.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    const handleTooltipShow = ()=>{
        debouncedLeadingFetch();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LivePagesByLineLastUpdated',
                action: 'displayed',
                actionSubject: 'tooltip',
                actionSubjectId: 'bylineLastUpdate',
                attributes: {
                    contentId: contentId,
                    isLivePage: true
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        onShow: handleTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
        version: version,
        loading: loading
    }));
});



var $aKxcs = parcelRequire("aKxcs");


var $6iOCg = parcelRequire("6iOCg");


var $5YSiR = parcelRequire("5YSiR");


var $3TrzI = parcelRequire("3TrzI");

const $3db5129918072e70$export$a6a69f624b6c8259 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(82);
    const { contentId: contentId, author: author, owner: owner, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, generatedBy: generatedBy, isCurrentUserContributor: isCurrentUserContributor, editorBylineContainerRef: t1 } = t0;
    const editorBylineContainerRef = t1 === undefined ? undefined : t1;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const { approvalRequest: approvalRequest, availableWorkflowStatuses: availableWorkflowStatuses } = (0, $laFNM.useApprovals)();
    let t2;
    if ($[0] !== approvalRequest || $[1] !== availableWorkflowStatuses) {
        t2 = !!approvalRequest?.application?.workflowStatusId && availableWorkflowStatuses.some((s)=>s.id === approvalRequest.application.workflowStatusId) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[0] = approvalRequest;
        $[1] = availableWorkflowStatuses;
        $[2] = t2;
    } else t2 = $[2];
    const hasActiveWorkflowStatus = t2;
    const { isAudioV3Enabled: isAudioV3Enabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId,
            isDraft: true
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = {
            fetchPolicy: "cache-first",
            variables: t3,
            skip: !Boolean(window.__SSR_RENDERED__)
        };
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6900e8f8fbd4b479$export$2e2bcd8739ae039), {
        ...t4,
        __callerPackage__: "@confluence/content-header"
    });
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const eligibleForReactions = isEmbeddedConfluence ? hasReactions : true;
    const renderReactions = (isLivePage || !isUnpublishedDraft) && eligibleForReactions;
    const t5 = renderReactions ? undefined : "space.050";
    let t6;
    if ($[7] !== author || $[8] !== contributorCountWithoutOwner || $[9] !== generatedBy || $[10] !== owner) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "liveDoc",
            contributorCountWithoutOwner: contributorCountWithoutOwner,
            generatedBy: generatedBy
        });
        $[7] = author;
        $[8] = contributorCountWithoutOwner;
        $[9] = generatedBy;
        $[10] = owner;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: t5
        }, t6);
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    const singleLineOwnershipByline = t7;
    const shouldHideMarkdownModeOptions = isMarkdownMode;
    const showByLineExtensions = isEmbeddedConfluence ? hasByLineExtensions : true;
    const showThirdPartyByLineExtensions = showByLineExtensions && !shouldHideMarkdownModeOptions;
    let t8;
    if ($[15] !== generatedBy || $[16] !== isEmbeddedConfluence) {
        t8 = generatedBy === (0, $3TrzI.AI_PLANNER_GENERATED_BY) && (0, $9wGTI.fg)("confluence_ai_planner_sync_byline") && !isEmbeddedConfluence;
        $[15] = generatedBy;
        $[16] = isEmbeddedConfluence;
        $[17] = t8;
    } else t8 = $[17];
    const shouldRenderAIPlannerSyncByline = t8;
    let t9;
    if ($[18] !== contentId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId
        });
        $[18] = contentId;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            (0, $bJX6u.ContentStateStateContainer)
        ];
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== contentId || $[22] !== contentType || $[23] !== data?.singleContent?.contentState || $[24] !== hasActiveWorkflowStatus || $[25] !== isKnowledgeBaseSpace || $[26] !== isLivePage || $[27] !== isPublishingContent || $[28] !== userOffline || $[29] !== viewMode) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t10
        }, (contentStateState)=>{
            if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63EIj.RendererContentState), {
                contentId: contentId,
                hasSeparator: false,
                isDraft: !isLivePage
            });
            const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
            if (contentStateState.state.contentState || hasActiveWorkflowStatus || isKnowledgeBaseSpace || isSSRRenderedOnLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                floatingToolbarButtonStyle: {
                    alignItems: "center",
                    height: "24px"
                },
                isViewMode: viewMode ?? false
            });
            else return null;
        });
        $[21] = contentId;
        $[22] = contentType;
        $[23] = data?.singleContent?.contentState;
        $[24] = hasActiveWorkflowStatus;
        $[25] = isKnowledgeBaseSpace;
        $[26] = isLivePage;
        $[27] = isPublishingContent;
        $[28] = userOffline;
        $[29] = viewMode;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== contentId || $[32] !== editorApi || $[33] !== isLivePage) {
        t12 = isLivePage && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dce34ae8b4376c02$export$e4a26074619839f4), {
            contentId: contentId,
            editorApi: editorApi
        });
        $[31] = contentId;
        $[32] = editorApi;
        $[33] = isLivePage;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== contentId || $[36] !== editorApi || $[37] !== shouldHideMarkdownModeOptions) {
        t13 = !shouldHideMarkdownModeOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
            contentId: contentId,
            editorApi: editorApi,
            isInEditor: true
        });
        $[35] = contentId;
        $[36] = editorApi;
        $[37] = shouldHideMarkdownModeOptions;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8h2Hn.BylineConnections), null);
        $[39] = t14;
    } else t14 = $[39];
    let t15;
    if ($[40] !== contentId || $[41] !== contentType || $[42] !== isAudioBylineEntrypointEnabled || $[43] !== isAudioV3Enabled || $[44] !== shouldHideMarkdownModeOptions) {
        t15 = isAudioV3Enabled && isAudioBylineEntrypointEnabled && !shouldHideMarkdownModeOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType
        });
        $[40] = contentId;
        $[41] = contentType;
        $[42] = isAudioBylineEntrypointEnabled;
        $[43] = isAudioV3Enabled;
        $[44] = shouldHideMarkdownModeOptions;
        $[45] = t15;
    } else t15 = $[45];
    let t16;
    if ($[46] !== author || $[47] !== contentId || $[48] !== isLivePage || $[49] !== isUnpublishedDraft) {
        t16 = (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fImWv.AnalyticsByLine), {
            contentId: contentId,
            contentAuthorId: author.userId
        });
        $[46] = author;
        $[47] = contentId;
        $[48] = isLivePage;
        $[49] = isUnpublishedDraft;
        $[50] = t16;
    } else t16 = $[50];
    let t17;
    if ($[51] !== t11 || $[52] !== t12 || $[53] !== t13 || $[54] !== t15 || $[55] !== t16 || $[56] !== t9) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, t11, t12, t13, t14, t15, t16);
        $[51] = t11;
        $[52] = t12;
        $[53] = t13;
        $[54] = t15;
        $[55] = t16;
        $[56] = t9;
        $[57] = t17;
    } else t17 = $[57];
    const byLineExtensions = t17;
    const t18 = showByLineExtensions && byLineExtensions;
    let t19;
    if ($[58] !== contentId || $[59] !== contentType || $[60] !== editorBylineContainerRef || $[61] !== isCurrentUserContributor || $[62] !== renderReactions || $[63] !== spaceId || $[64] !== userOffline) {
        t19 = renderReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06f66a283e23582e$export$37ba4ba009bc421f), {
            contentId: contentId,
            spaceId: spaceId || "",
            isDisabled: userOffline,
            contentType: contentType,
            isCurrentUserContributor: isCurrentUserContributor,
            editorBylineContainerRef: editorBylineContainerRef
        });
        $[58] = contentId;
        $[59] = contentType;
        $[60] = editorBylineContainerRef;
        $[61] = isCurrentUserContributor;
        $[62] = renderReactions;
        $[63] = spaceId;
        $[64] = userOffline;
        $[65] = t19;
    } else t19 = $[65];
    let t20;
    if ($[66] !== t18 || $[67] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t18, t19);
        $[66] = t18;
        $[67] = t19;
        $[68] = t20;
    } else t20 = $[68];
    const ByLineCommonContent = t20;
    const showByLineContributors = isEmbeddedConfluence ? hasByLineContributors : true;
    const t21 = contentType;
    const t22 = showByLineContributors && singleLineOwnershipByline;
    let t23;
    if ($[69] !== contentId || $[70] !== contentType || $[71] !== generatedBy || $[72] !== isEmbeddedConfluence || $[73] !== shouldRenderAIPlannerSyncByline) {
        t23 = shouldRenderAIPlannerSyncByline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5YSiR.LazyAIPlannerSyncByline), {
            contentId: contentId,
            contentType: contentType,
            generatedBy: generatedBy,
            isEmbeddedConfluence: isEmbeddedConfluence
        });
        $[69] = contentId;
        $[70] = contentType;
        $[71] = generatedBy;
        $[72] = isEmbeddedConfluence;
        $[73] = shouldRenderAIPlannerSyncByline;
        $[74] = t23;
    } else t23 = $[74];
    let t24;
    if ($[75] !== ByLineCommonContent || $[76] !== contentId || $[77] !== showThirdPartyByLineExtensions || $[78] !== t21 || $[79] !== t22 || $[80] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            contentType: t21,
            showByLineExtensions: showThirdPartyByLineExtensions
        }, t22, t23, ByLineCommonContent);
        $[75] = ByLineCommonContent;
        $[76] = contentId;
        $[77] = showThirdPartyByLineExtensions;
        $[78] = t21;
        $[79] = t22;
        $[80] = t23;
        $[81] = t24;
    } else t24 = $[81];
    return t24;
});



var $ausiN = parcelRequire("ausiN");


var $83fWZ = parcelRequire("83fWZ");

const $d898e2893b08edbf$export$7ee26dfdd6e2e40f = ({ contentId: contentId, contentType: contentType, viewMode: viewMode, isPublishingContent: isPublishingContent, isKnowledgeBaseSpace: isKnowledgeBaseSpace, userOffline: userOffline, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, editorBylineContainerRef: editorBylineContainerRef })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const lastLoadedQueryData = (0, $42omo.useRef)(null);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $fxLAA.default), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
            ...isUnpublishedDraft && !isLivePage && {
                status: [
                    'draft'
                ]
            }
        },
        context: {
            single: true
        },
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "@confluence/content-header"
    });
    const renderByLine = ()=>{
        // HACK: status: ['draft'] for unpublished drafts results in a weird case where loading is true and we also have the data. Need to investigate this further, but this hack should work for now.
        // happens because isUnpublishedDraft goes from false to true during SSR. ideally we would either always get the right data, or not need it (pass status: ['draft', 'current'] all the time - which could cause caching issues)
        const hasSSRData = renderServerPlaceholder && Boolean(data);
        if (loading && !hasSSRData) {
            // If we're loading because the LivePagesByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = data?.content?.nodes?.[0];
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const contributorProps = $d898e2893b08edbf$export$6dbfb663651d0abf(content, data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3db5129918072e70$export$a6a69f624b6c8259), {
            ...contributorProps,
            contentId: contentId,
            contentType: contentType,
            viewMode: viewMode,
            isPublishingContent: isPublishingContent,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            userOffline: userOffline,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions,
            editorBylineContainerRef: editorBylineContainerRef
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, renderByLine());
};
const $d898e2893b08edbf$export$6dbfb663651d0abf = (content, data)=>{
    const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
    const owner = content?.history?.ownedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
    const contributorsCount = data?.contentContributors?.count || 0;
    const isOwnerContributor = data?.contentContributors?.isOwnerContributor;
    const generatedBy = content?.contentProperties?.latest?.generatedBy;
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor || false;
    return {
        author: author,
        owner: owner,
        contributorsCount: contributorsCount,
        isOwnerContributor: isOwnerContributor,
        generatedBy: generatedBy,
        isCurrentUserContributor: isCurrentUserContributor
    };
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d54487d18f54cde1$var$EditorByLineWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d54487d18f54cde1$export$a5fad03eb2e226dc = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const editorBylineContainerRef = (0, $42omo.useRef)(null);
    if (isSpaceOverview) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6mKj3.expValEquals)("cc_editor_two_stage_hydration_removal", "editorByLineArea", true);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== contentType || $[3] !== editorApi || $[4] !== hasByLineContributors || $[5] !== hasByLineExtensions || $[6] !== hasReactions || $[7] !== isKnowledgeBaseSpace || $[8] !== isPublishingContent || $[9] !== isUnpublishedDraft || $[10] !== userOffline || $[11] !== viewMode) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d898e2893b08edbf$export$7ee26dfdd6e2e40f), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            viewMode: viewMode,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions,
            editorBylineContainerRef: editorBylineContainerRef
        });
        $[1] = contentId;
        $[2] = contentType;
        $[3] = editorApi;
        $[4] = hasByLineContributors;
        $[5] = hasByLineExtensions;
        $[6] = hasReactions;
        $[7] = isKnowledgeBaseSpace;
        $[8] = isPublishingContent;
        $[9] = isUnpublishedDraft;
        $[10] = userOffline;
        $[11] = viewMode;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== ssrPlaceholderIdProp || $[14] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
            name: "editor-byline",
            enabled: !t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
            "data-vc": "editor-byline-wrapper",
            ...ssrPlaceholderIdProp,
            ref: editorBylineContainerRef
        }, t2));
        $[13] = ssrPlaceholderIdProp;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
};
module.exports["EditorByLineArea"] = $d54487d18f54cde1$export$a5fad03eb2e226dc;

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("e6vsp"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("e6vsp", function(module, exports) {

let $a44a06fe2f01a381$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a44a06fe2f01a381$var$load("fFc5s"),
    $a44a06fe2f01a381$var$load("9opeZ")
]).then(()=>parcelRequire('44FvL'));

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("lVkeN"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("lVkeN", function(module, exports) {

let $ff5e9e9c264a56d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ff5e9e9c264a56d0$var$load("fFc5s"),
    $ff5e9e9c264a56d0$var$load("hhss7"),
    $ff5e9e9c264a56d0$var$load("1CUOt"),
    $ff5e9e9c264a56d0$var$load("guVy6"),
    $ff5e9e9c264a56d0$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("JTIzG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const isAHMOnlyEnabled = (0, $42omo.useMemo)(()=>isAtlassianHostedLLMOnlyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_disable_if_ahm_enabled'), [
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAIPolicyAndBrowserSupportEnabled = (0, $42omo.useMemo)(()=>isAdminHubAIEnabled && // AdminHub AI is enabled
        isAIEarlyAccessEnabled && // AI Early Access is enabled
        audioSupportedByBrowser && // Audio is supported by browser
        !isAHMOnlyEnabled, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        audioSupportedByBrowser,
        isAHMOnlyEnabled
    ]);
    const isAudioV3Enabled = (0, $42omo.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const isAudioBylineEntrypointEnabled = (0, $42omo.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_ai_consumption_byline'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const audioBriefingNudgeExperimentState = (0, $42omo.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $42omo.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("gqypm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip, fetchPolicy: fetchPolicy })=>{
    const legacyResult = (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        fetchPolicy: fetchPolicy
    });
    if (!(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return {
        data: legacyResult.data,
        loading: legacyResult.loading,
        error: legacyResult.error ?? undefined
    };
    // Exp on: adapt traits result into legacy data/loading/error shape
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== resolvedAttachmentId || $[6] !== returnBlockedExtensions || $[7] !== skipQuery || $[8] !== spaceContextOnly || $[9] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = resolvedAttachmentId;
        $[6] = returnBlockedExtensions;
        $[7] = skipQuery;
        $[8] = spaceContextOnly;
        $[9] = spaceKey;
        $[10] = t3;
    } else t3 = $[10];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[11] !== extsError || $[12] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[11] = extsError;
        $[12] = spaceError;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[15] !== extsData || $[16] !== extsError || $[17] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[15] = extsData;
        $[16] = extsError;
        $[17] = extsLoading;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const includeAttachmentId = attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions');
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...includeAttachmentId ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("kxhju", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "@confluence/web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("lOI2p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onClose: onClose, popupRef: popupRef, triggerRef: triggerRef } = t0;
    let t1;
    let t2;
    if ($[0] !== onClose || $[1] !== popupRef || $[2] !== triggerRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const keyDownEvent = (t3)=>{
                const { key: key } = t3;
                if (key === "Escape" || key === "Esc") onClose();
            };
            const clickEvent = (event)=>{
                if (!document.body.contains(event.target)) return;
                if (popupRef && popupRef.contains(event.target)) return;
                if (triggerRef && triggerRef.contains(event.target)) return;
                if (event.target.closest(".atlaskit-portal-container [role=dialog]")) return;
                onClose();
            };
            window.addEventListener("click", clickEvent);
            window.addEventListener("keydown", keyDownEvent);
            return ()=>{
                window.removeEventListener("click", clickEvent);
                window.removeEventListener("keydown", keyDownEvent);
            };
        };
        t2 = [
            popupRef,
            triggerRef,
            onClose
        ];
        $[0] = onClose;
        $[1] = popupRef;
        $[2] = triggerRef;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("kEzqP"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("htSjI"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("bHz6z"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("8n9VB"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("bBk1i"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("eTMpD"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("7v00O"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("kLN2P"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("cRCu0"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("jxVJv"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("erRqA"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("gICEw"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("kEzqP", function(module, exports) {

let $f09307103d820dc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f09307103d820dc9$var$load("2YffH"),
    $f09307103d820dc9$var$load("eNXrl"),
    $f09307103d820dc9$var$load("7o5Pu"),
    $f09307103d820dc9$var$load("jjZO0"),
    $f09307103d820dc9$var$load("AGwzU"),
    $f09307103d820dc9$var$load("lo4Uk"),
    $f09307103d820dc9$var$load("bUxH9"),
    $f09307103d820dc9$var$load("eBRUf"),
    $f09307103d820dc9$var$load("i6XKW"),
    $f09307103d820dc9$var$load("1BN67"),
    $f09307103d820dc9$var$load("2tIxk"),
    $f09307103d820dc9$var$load("dLq4a"),
    $f09307103d820dc9$var$load("h9S8v"),
    $f09307103d820dc9$var$load("27glK"),
    $f09307103d820dc9$var$load("bvY53"),
    $f09307103d820dc9$var$load("lTK3c"),
    $f09307103d820dc9$var$load("1WXdc"),
    $f09307103d820dc9$var$load("3GuOt"),
    $f09307103d820dc9$var$load("hUmZG"),
    $f09307103d820dc9$var$load("h4Nf7"),
    $f09307103d820dc9$var$load("5o4Kn"),
    $f09307103d820dc9$var$load("6rS39"),
    $f09307103d820dc9$var$load("3MYQs"),
    $f09307103d820dc9$var$load("6SWFK"),
    $f09307103d820dc9$var$load("5zapo"),
    $f09307103d820dc9$var$load("6wr18"),
    $f09307103d820dc9$var$load("9atVd"),
    $f09307103d820dc9$var$load("ffEVr"),
    $f09307103d820dc9$var$load("Y76xf"),
    $f09307103d820dc9$var$load("jbM5v"),
    $f09307103d820dc9$var$load("219St"),
    $f09307103d820dc9$var$load("b1DMS"),
    $f09307103d820dc9$var$load("lVrrs"),
    $f09307103d820dc9$var$load("3NkiL"),
    $f09307103d820dc9$var$load("aqfyB"),
    $f09307103d820dc9$var$load("fCxvi"),
    $f09307103d820dc9$var$load("1bbSu"),
    $f09307103d820dc9$var$load("kbwlB"),
    $f09307103d820dc9$var$load("Wowvf"),
    $f09307103d820dc9$var$load("cRtGo"),
    $f09307103d820dc9$var$load("s4822"),
    $f09307103d820dc9$var$load("hhss7"),
    $f09307103d820dc9$var$load("2OkLl"),
    $f09307103d820dc9$var$load("lnKog"),
    $f09307103d820dc9$var$load("h3ABO"),
    $f09307103d820dc9$var$load("kC80R"),
    $f09307103d820dc9$var$load("7EorR"),
    $f09307103d820dc9$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("htSjI", function(module, exports) {

let $cb9f474c99a933bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb9f474c99a933bb$var$load("2YffH"),
    $cb9f474c99a933bb$var$load("eNXrl"),
    $cb9f474c99a933bb$var$load("7o5Pu"),
    $cb9f474c99a933bb$var$load("jjZO0"),
    $cb9f474c99a933bb$var$load("AGwzU"),
    $cb9f474c99a933bb$var$load("lo4Uk"),
    $cb9f474c99a933bb$var$load("bUxH9"),
    $cb9f474c99a933bb$var$load("eBRUf"),
    $cb9f474c99a933bb$var$load("i6XKW"),
    $cb9f474c99a933bb$var$load("1BN67"),
    $cb9f474c99a933bb$var$load("2tIxk"),
    $cb9f474c99a933bb$var$load("dLq4a"),
    $cb9f474c99a933bb$var$load("h9S8v"),
    $cb9f474c99a933bb$var$load("27glK"),
    $cb9f474c99a933bb$var$load("bvY53"),
    $cb9f474c99a933bb$var$load("lTK3c"),
    $cb9f474c99a933bb$var$load("1WXdc"),
    $cb9f474c99a933bb$var$load("3GuOt"),
    $cb9f474c99a933bb$var$load("hUmZG"),
    $cb9f474c99a933bb$var$load("h4Nf7"),
    $cb9f474c99a933bb$var$load("5o4Kn"),
    $cb9f474c99a933bb$var$load("6rS39"),
    $cb9f474c99a933bb$var$load("3MYQs"),
    $cb9f474c99a933bb$var$load("6SWFK"),
    $cb9f474c99a933bb$var$load("5zapo"),
    $cb9f474c99a933bb$var$load("6wr18"),
    $cb9f474c99a933bb$var$load("9atVd"),
    $cb9f474c99a933bb$var$load("ffEVr"),
    $cb9f474c99a933bb$var$load("Y76xf"),
    $cb9f474c99a933bb$var$load("jbM5v"),
    $cb9f474c99a933bb$var$load("219St"),
    $cb9f474c99a933bb$var$load("b1DMS"),
    $cb9f474c99a933bb$var$load("lVrrs"),
    $cb9f474c99a933bb$var$load("3NkiL"),
    $cb9f474c99a933bb$var$load("aqfyB"),
    $cb9f474c99a933bb$var$load("fCxvi"),
    $cb9f474c99a933bb$var$load("1bbSu"),
    $cb9f474c99a933bb$var$load("kbwlB"),
    $cb9f474c99a933bb$var$load("Wowvf"),
    $cb9f474c99a933bb$var$load("cRtGo"),
    $cb9f474c99a933bb$var$load("s4822"),
    $cb9f474c99a933bb$var$load("hhss7"),
    $cb9f474c99a933bb$var$load("2OkLl"),
    $cb9f474c99a933bb$var$load("lnKog"),
    $cb9f474c99a933bb$var$load("h3ABO"),
    $cb9f474c99a933bb$var$load("kC80R"),
    $cb9f474c99a933bb$var$load("7EorR"),
    $cb9f474c99a933bb$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("bHz6z", function(module, exports) {

let $884ef0fc65c8c875$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $884ef0fc65c8c875$var$load("2YffH"),
    $884ef0fc65c8c875$var$load("eNXrl"),
    $884ef0fc65c8c875$var$load("7o5Pu"),
    $884ef0fc65c8c875$var$load("jjZO0"),
    $884ef0fc65c8c875$var$load("AGwzU"),
    $884ef0fc65c8c875$var$load("lo4Uk"),
    $884ef0fc65c8c875$var$load("bUxH9"),
    $884ef0fc65c8c875$var$load("eBRUf"),
    $884ef0fc65c8c875$var$load("i6XKW"),
    $884ef0fc65c8c875$var$load("1BN67"),
    $884ef0fc65c8c875$var$load("2tIxk"),
    $884ef0fc65c8c875$var$load("dLq4a"),
    $884ef0fc65c8c875$var$load("h9S8v"),
    $884ef0fc65c8c875$var$load("27glK"),
    $884ef0fc65c8c875$var$load("bvY53"),
    $884ef0fc65c8c875$var$load("lTK3c"),
    $884ef0fc65c8c875$var$load("1WXdc"),
    $884ef0fc65c8c875$var$load("3GuOt"),
    $884ef0fc65c8c875$var$load("hUmZG"),
    $884ef0fc65c8c875$var$load("h4Nf7"),
    $884ef0fc65c8c875$var$load("5o4Kn"),
    $884ef0fc65c8c875$var$load("6rS39"),
    $884ef0fc65c8c875$var$load("3MYQs"),
    $884ef0fc65c8c875$var$load("6SWFK"),
    $884ef0fc65c8c875$var$load("5zapo"),
    $884ef0fc65c8c875$var$load("6wr18"),
    $884ef0fc65c8c875$var$load("9atVd"),
    $884ef0fc65c8c875$var$load("ffEVr"),
    $884ef0fc65c8c875$var$load("Y76xf"),
    $884ef0fc65c8c875$var$load("jbM5v"),
    $884ef0fc65c8c875$var$load("219St"),
    $884ef0fc65c8c875$var$load("b1DMS"),
    $884ef0fc65c8c875$var$load("lVrrs"),
    $884ef0fc65c8c875$var$load("3NkiL"),
    $884ef0fc65c8c875$var$load("aqfyB"),
    $884ef0fc65c8c875$var$load("fCxvi"),
    $884ef0fc65c8c875$var$load("1bbSu"),
    $884ef0fc65c8c875$var$load("kbwlB"),
    $884ef0fc65c8c875$var$load("Wowvf"),
    $884ef0fc65c8c875$var$load("cRtGo"),
    $884ef0fc65c8c875$var$load("s4822"),
    $884ef0fc65c8c875$var$load("hhss7"),
    $884ef0fc65c8c875$var$load("2OkLl"),
    $884ef0fc65c8c875$var$load("lnKog"),
    $884ef0fc65c8c875$var$load("h3ABO"),
    $884ef0fc65c8c875$var$load("kC80R"),
    $884ef0fc65c8c875$var$load("7EorR"),
    $884ef0fc65c8c875$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("8n9VB", function(module, exports) {

let $61882c33b5345589$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $61882c33b5345589$var$load("2YffH"),
    $61882c33b5345589$var$load("jjZO0"),
    $61882c33b5345589$var$load("AGwzU"),
    $61882c33b5345589$var$load("bUxH9"),
    $61882c33b5345589$var$load("eBRUf"),
    $61882c33b5345589$var$load("i6XKW"),
    $61882c33b5345589$var$load("1BN67"),
    $61882c33b5345589$var$load("2tIxk"),
    $61882c33b5345589$var$load("dLq4a"),
    $61882c33b5345589$var$load("27glK"),
    $61882c33b5345589$var$load("bvY53"),
    $61882c33b5345589$var$load("lTK3c"),
    $61882c33b5345589$var$load("1WXdc"),
    $61882c33b5345589$var$load("3GuOt"),
    $61882c33b5345589$var$load("hUmZG"),
    $61882c33b5345589$var$load("h4Nf7"),
    $61882c33b5345589$var$load("5o4Kn"),
    $61882c33b5345589$var$load("6rS39"),
    $61882c33b5345589$var$load("3MYQs"),
    $61882c33b5345589$var$load("6SWFK"),
    $61882c33b5345589$var$load("5zapo"),
    $61882c33b5345589$var$load("6wr18"),
    $61882c33b5345589$var$load("9atVd"),
    $61882c33b5345589$var$load("ffEVr"),
    $61882c33b5345589$var$load("Y76xf"),
    $61882c33b5345589$var$load("jbM5v"),
    $61882c33b5345589$var$load("219St"),
    $61882c33b5345589$var$load("b1DMS"),
    $61882c33b5345589$var$load("lVrrs"),
    $61882c33b5345589$var$load("3NkiL"),
    $61882c33b5345589$var$load("aqfyB"),
    $61882c33b5345589$var$load("fCxvi"),
    $61882c33b5345589$var$load("1bbSu"),
    $61882c33b5345589$var$load("kbwlB"),
    $61882c33b5345589$var$load("Wowvf"),
    $61882c33b5345589$var$load("cRtGo"),
    $61882c33b5345589$var$load("s4822"),
    $61882c33b5345589$var$load("hhss7"),
    $61882c33b5345589$var$load("2OkLl"),
    $61882c33b5345589$var$load("h3ABO"),
    $61882c33b5345589$var$load("kC80R"),
    $61882c33b5345589$var$load("7EorR"),
    $61882c33b5345589$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("bBk1i", function(module, exports) {

let $8722adf1066c2309$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8722adf1066c2309$var$load("2YffH"),
    $8722adf1066c2309$var$load("jjZO0"),
    $8722adf1066c2309$var$load("AGwzU"),
    $8722adf1066c2309$var$load("bUxH9"),
    $8722adf1066c2309$var$load("eBRUf"),
    $8722adf1066c2309$var$load("i6XKW"),
    $8722adf1066c2309$var$load("1BN67"),
    $8722adf1066c2309$var$load("2tIxk"),
    $8722adf1066c2309$var$load("dLq4a"),
    $8722adf1066c2309$var$load("27glK"),
    $8722adf1066c2309$var$load("bvY53"),
    $8722adf1066c2309$var$load("lTK3c"),
    $8722adf1066c2309$var$load("1WXdc"),
    $8722adf1066c2309$var$load("3GuOt"),
    $8722adf1066c2309$var$load("hUmZG"),
    $8722adf1066c2309$var$load("h4Nf7"),
    $8722adf1066c2309$var$load("5o4Kn"),
    $8722adf1066c2309$var$load("6rS39"),
    $8722adf1066c2309$var$load("3MYQs"),
    $8722adf1066c2309$var$load("6SWFK"),
    $8722adf1066c2309$var$load("5zapo"),
    $8722adf1066c2309$var$load("6wr18"),
    $8722adf1066c2309$var$load("9atVd"),
    $8722adf1066c2309$var$load("ffEVr"),
    $8722adf1066c2309$var$load("Y76xf"),
    $8722adf1066c2309$var$load("jbM5v"),
    $8722adf1066c2309$var$load("219St"),
    $8722adf1066c2309$var$load("b1DMS"),
    $8722adf1066c2309$var$load("lVrrs"),
    $8722adf1066c2309$var$load("3NkiL"),
    $8722adf1066c2309$var$load("aqfyB"),
    $8722adf1066c2309$var$load("fCxvi"),
    $8722adf1066c2309$var$load("1bbSu"),
    $8722adf1066c2309$var$load("kbwlB"),
    $8722adf1066c2309$var$load("Wowvf"),
    $8722adf1066c2309$var$load("cRtGo"),
    $8722adf1066c2309$var$load("s4822"),
    $8722adf1066c2309$var$load("hhss7"),
    $8722adf1066c2309$var$load("2OkLl"),
    $8722adf1066c2309$var$load("h3ABO"),
    $8722adf1066c2309$var$load("kC80R"),
    $8722adf1066c2309$var$load("7EorR"),
    $8722adf1066c2309$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("eTMpD", function(module, exports) {

let $ad8bc16d3b47fae0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ad8bc16d3b47fae0$var$load("2YffH"),
    $ad8bc16d3b47fae0$var$load("jjZO0"),
    $ad8bc16d3b47fae0$var$load("AGwzU"),
    $ad8bc16d3b47fae0$var$load("bUxH9"),
    $ad8bc16d3b47fae0$var$load("eBRUf"),
    $ad8bc16d3b47fae0$var$load("i6XKW"),
    $ad8bc16d3b47fae0$var$load("1BN67"),
    $ad8bc16d3b47fae0$var$load("2tIxk"),
    $ad8bc16d3b47fae0$var$load("dLq4a"),
    $ad8bc16d3b47fae0$var$load("27glK"),
    $ad8bc16d3b47fae0$var$load("bvY53"),
    $ad8bc16d3b47fae0$var$load("lTK3c"),
    $ad8bc16d3b47fae0$var$load("1WXdc"),
    $ad8bc16d3b47fae0$var$load("3GuOt"),
    $ad8bc16d3b47fae0$var$load("hUmZG"),
    $ad8bc16d3b47fae0$var$load("h4Nf7"),
    $ad8bc16d3b47fae0$var$load("5o4Kn"),
    $ad8bc16d3b47fae0$var$load("6rS39"),
    $ad8bc16d3b47fae0$var$load("3MYQs"),
    $ad8bc16d3b47fae0$var$load("6SWFK"),
    $ad8bc16d3b47fae0$var$load("5zapo"),
    $ad8bc16d3b47fae0$var$load("6wr18"),
    $ad8bc16d3b47fae0$var$load("9atVd"),
    $ad8bc16d3b47fae0$var$load("ffEVr"),
    $ad8bc16d3b47fae0$var$load("Y76xf"),
    $ad8bc16d3b47fae0$var$load("jbM5v"),
    $ad8bc16d3b47fae0$var$load("219St"),
    $ad8bc16d3b47fae0$var$load("b1DMS"),
    $ad8bc16d3b47fae0$var$load("lVrrs"),
    $ad8bc16d3b47fae0$var$load("3NkiL"),
    $ad8bc16d3b47fae0$var$load("aqfyB"),
    $ad8bc16d3b47fae0$var$load("fCxvi"),
    $ad8bc16d3b47fae0$var$load("1bbSu"),
    $ad8bc16d3b47fae0$var$load("kbwlB"),
    $ad8bc16d3b47fae0$var$load("Wowvf"),
    $ad8bc16d3b47fae0$var$load("cRtGo"),
    $ad8bc16d3b47fae0$var$load("s4822"),
    $ad8bc16d3b47fae0$var$load("hhss7"),
    $ad8bc16d3b47fae0$var$load("2OkLl"),
    $ad8bc16d3b47fae0$var$load("h3ABO"),
    $ad8bc16d3b47fae0$var$load("kC80R"),
    $ad8bc16d3b47fae0$var$load("7EorR"),
    $ad8bc16d3b47fae0$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("7v00O", function(module, exports) {

let $575b70107d79196b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $575b70107d79196b$var$load("2YffH"),
    $575b70107d79196b$var$load("jjZO0"),
    $575b70107d79196b$var$load("AGwzU"),
    $575b70107d79196b$var$load("bUxH9"),
    $575b70107d79196b$var$load("eBRUf"),
    $575b70107d79196b$var$load("i6XKW"),
    $575b70107d79196b$var$load("1BN67"),
    $575b70107d79196b$var$load("2tIxk"),
    $575b70107d79196b$var$load("dLq4a"),
    $575b70107d79196b$var$load("27glK"),
    $575b70107d79196b$var$load("bvY53"),
    $575b70107d79196b$var$load("lTK3c"),
    $575b70107d79196b$var$load("1WXdc"),
    $575b70107d79196b$var$load("3GuOt"),
    $575b70107d79196b$var$load("hUmZG"),
    $575b70107d79196b$var$load("h4Nf7"),
    $575b70107d79196b$var$load("5o4Kn"),
    $575b70107d79196b$var$load("6rS39"),
    $575b70107d79196b$var$load("3MYQs"),
    $575b70107d79196b$var$load("6SWFK"),
    $575b70107d79196b$var$load("5zapo"),
    $575b70107d79196b$var$load("6wr18"),
    $575b70107d79196b$var$load("9atVd"),
    $575b70107d79196b$var$load("ffEVr"),
    $575b70107d79196b$var$load("Y76xf"),
    $575b70107d79196b$var$load("jbM5v"),
    $575b70107d79196b$var$load("219St"),
    $575b70107d79196b$var$load("b1DMS"),
    $575b70107d79196b$var$load("lVrrs"),
    $575b70107d79196b$var$load("3NkiL"),
    $575b70107d79196b$var$load("aqfyB"),
    $575b70107d79196b$var$load("fCxvi"),
    $575b70107d79196b$var$load("1bbSu"),
    $575b70107d79196b$var$load("kbwlB"),
    $575b70107d79196b$var$load("Wowvf"),
    $575b70107d79196b$var$load("cRtGo"),
    $575b70107d79196b$var$load("s4822"),
    $575b70107d79196b$var$load("hhss7"),
    $575b70107d79196b$var$load("2OkLl"),
    $575b70107d79196b$var$load("lnKog"),
    $575b70107d79196b$var$load("h3ABO"),
    $575b70107d79196b$var$load("kC80R"),
    $575b70107d79196b$var$load("7EorR"),
    $575b70107d79196b$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("kLN2P", function(module, exports) {

let $f1ee3db220483530$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f1ee3db220483530$var$load("2YffH"),
    $f1ee3db220483530$var$load("jjZO0"),
    $f1ee3db220483530$var$load("AGwzU"),
    $f1ee3db220483530$var$load("lo4Uk"),
    $f1ee3db220483530$var$load("bUxH9"),
    $f1ee3db220483530$var$load("eBRUf"),
    $f1ee3db220483530$var$load("i6XKW"),
    $f1ee3db220483530$var$load("1BN67"),
    $f1ee3db220483530$var$load("2tIxk"),
    $f1ee3db220483530$var$load("dLq4a"),
    $f1ee3db220483530$var$load("h9S8v"),
    $f1ee3db220483530$var$load("27glK"),
    $f1ee3db220483530$var$load("bvY53"),
    $f1ee3db220483530$var$load("lTK3c"),
    $f1ee3db220483530$var$load("1WXdc"),
    $f1ee3db220483530$var$load("3GuOt"),
    $f1ee3db220483530$var$load("hUmZG"),
    $f1ee3db220483530$var$load("h4Nf7"),
    $f1ee3db220483530$var$load("5o4Kn"),
    $f1ee3db220483530$var$load("6rS39"),
    $f1ee3db220483530$var$load("3MYQs"),
    $f1ee3db220483530$var$load("6SWFK"),
    $f1ee3db220483530$var$load("5zapo"),
    $f1ee3db220483530$var$load("6wr18"),
    $f1ee3db220483530$var$load("9atVd"),
    $f1ee3db220483530$var$load("ffEVr"),
    $f1ee3db220483530$var$load("Y76xf"),
    $f1ee3db220483530$var$load("jbM5v"),
    $f1ee3db220483530$var$load("219St"),
    $f1ee3db220483530$var$load("b1DMS"),
    $f1ee3db220483530$var$load("lVrrs"),
    $f1ee3db220483530$var$load("3NkiL"),
    $f1ee3db220483530$var$load("aqfyB"),
    $f1ee3db220483530$var$load("fCxvi"),
    $f1ee3db220483530$var$load("1bbSu"),
    $f1ee3db220483530$var$load("kbwlB"),
    $f1ee3db220483530$var$load("Wowvf"),
    $f1ee3db220483530$var$load("cRtGo"),
    $f1ee3db220483530$var$load("s4822"),
    $f1ee3db220483530$var$load("hhss7"),
    $f1ee3db220483530$var$load("2OkLl"),
    $f1ee3db220483530$var$load("lnKog"),
    $f1ee3db220483530$var$load("h3ABO"),
    $f1ee3db220483530$var$load("kC80R"),
    $f1ee3db220483530$var$load("7EorR"),
    $f1ee3db220483530$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("cRCu0", function(module, exports) {

let $95d8492e7b6bd468$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $95d8492e7b6bd468$var$load("2YffH"),
    $95d8492e7b6bd468$var$load("jjZO0"),
    $95d8492e7b6bd468$var$load("AGwzU"),
    $95d8492e7b6bd468$var$load("lo4Uk"),
    $95d8492e7b6bd468$var$load("bUxH9"),
    $95d8492e7b6bd468$var$load("eBRUf"),
    $95d8492e7b6bd468$var$load("i6XKW"),
    $95d8492e7b6bd468$var$load("1BN67"),
    $95d8492e7b6bd468$var$load("2tIxk"),
    $95d8492e7b6bd468$var$load("dLq4a"),
    $95d8492e7b6bd468$var$load("h9S8v"),
    $95d8492e7b6bd468$var$load("27glK"),
    $95d8492e7b6bd468$var$load("bvY53"),
    $95d8492e7b6bd468$var$load("lTK3c"),
    $95d8492e7b6bd468$var$load("1WXdc"),
    $95d8492e7b6bd468$var$load("3GuOt"),
    $95d8492e7b6bd468$var$load("hUmZG"),
    $95d8492e7b6bd468$var$load("h4Nf7"),
    $95d8492e7b6bd468$var$load("5o4Kn"),
    $95d8492e7b6bd468$var$load("6rS39"),
    $95d8492e7b6bd468$var$load("3MYQs"),
    $95d8492e7b6bd468$var$load("6SWFK"),
    $95d8492e7b6bd468$var$load("5zapo"),
    $95d8492e7b6bd468$var$load("6wr18"),
    $95d8492e7b6bd468$var$load("9atVd"),
    $95d8492e7b6bd468$var$load("ffEVr"),
    $95d8492e7b6bd468$var$load("Y76xf"),
    $95d8492e7b6bd468$var$load("jbM5v"),
    $95d8492e7b6bd468$var$load("219St"),
    $95d8492e7b6bd468$var$load("b1DMS"),
    $95d8492e7b6bd468$var$load("lVrrs"),
    $95d8492e7b6bd468$var$load("3NkiL"),
    $95d8492e7b6bd468$var$load("aqfyB"),
    $95d8492e7b6bd468$var$load("fCxvi"),
    $95d8492e7b6bd468$var$load("1bbSu"),
    $95d8492e7b6bd468$var$load("kbwlB"),
    $95d8492e7b6bd468$var$load("Wowvf"),
    $95d8492e7b6bd468$var$load("cRtGo"),
    $95d8492e7b6bd468$var$load("s4822"),
    $95d8492e7b6bd468$var$load("hhss7"),
    $95d8492e7b6bd468$var$load("2OkLl"),
    $95d8492e7b6bd468$var$load("lnKog"),
    $95d8492e7b6bd468$var$load("h3ABO"),
    $95d8492e7b6bd468$var$load("kC80R"),
    $95d8492e7b6bd468$var$load("7EorR"),
    $95d8492e7b6bd468$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("jxVJv", function(module, exports) {

let $e3ade1f862e882d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e3ade1f862e882d7$var$load("2YffH"),
    $e3ade1f862e882d7$var$load("jjZO0"),
    $e3ade1f862e882d7$var$load("AGwzU"),
    $e3ade1f862e882d7$var$load("bUxH9"),
    $e3ade1f862e882d7$var$load("eBRUf"),
    $e3ade1f862e882d7$var$load("i6XKW"),
    $e3ade1f862e882d7$var$load("1BN67"),
    $e3ade1f862e882d7$var$load("2tIxk"),
    $e3ade1f862e882d7$var$load("dLq4a"),
    $e3ade1f862e882d7$var$load("27glK"),
    $e3ade1f862e882d7$var$load("bvY53"),
    $e3ade1f862e882d7$var$load("lTK3c"),
    $e3ade1f862e882d7$var$load("1WXdc"),
    $e3ade1f862e882d7$var$load("3GuOt"),
    $e3ade1f862e882d7$var$load("hUmZG"),
    $e3ade1f862e882d7$var$load("h4Nf7"),
    $e3ade1f862e882d7$var$load("5o4Kn"),
    $e3ade1f862e882d7$var$load("6rS39"),
    $e3ade1f862e882d7$var$load("3MYQs"),
    $e3ade1f862e882d7$var$load("6SWFK"),
    $e3ade1f862e882d7$var$load("5zapo"),
    $e3ade1f862e882d7$var$load("6wr18"),
    $e3ade1f862e882d7$var$load("9atVd"),
    $e3ade1f862e882d7$var$load("ffEVr"),
    $e3ade1f862e882d7$var$load("Y76xf"),
    $e3ade1f862e882d7$var$load("jbM5v"),
    $e3ade1f862e882d7$var$load("219St"),
    $e3ade1f862e882d7$var$load("b1DMS"),
    $e3ade1f862e882d7$var$load("lVrrs"),
    $e3ade1f862e882d7$var$load("3NkiL"),
    $e3ade1f862e882d7$var$load("aqfyB"),
    $e3ade1f862e882d7$var$load("fCxvi"),
    $e3ade1f862e882d7$var$load("1bbSu"),
    $e3ade1f862e882d7$var$load("kbwlB"),
    $e3ade1f862e882d7$var$load("Wowvf"),
    $e3ade1f862e882d7$var$load("cRtGo"),
    $e3ade1f862e882d7$var$load("s4822"),
    $e3ade1f862e882d7$var$load("hhss7"),
    $e3ade1f862e882d7$var$load("2OkLl"),
    $e3ade1f862e882d7$var$load("h3ABO"),
    $e3ade1f862e882d7$var$load("kC80R"),
    $e3ade1f862e882d7$var$load("7EorR"),
    $e3ade1f862e882d7$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("erRqA", function(module, exports) {

let $a84d07efd5d6386a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a84d07efd5d6386a$var$load("2YffH"),
    $a84d07efd5d6386a$var$load("jjZO0"),
    $a84d07efd5d6386a$var$load("AGwzU"),
    $a84d07efd5d6386a$var$load("bUxH9"),
    $a84d07efd5d6386a$var$load("eBRUf"),
    $a84d07efd5d6386a$var$load("i6XKW"),
    $a84d07efd5d6386a$var$load("1BN67"),
    $a84d07efd5d6386a$var$load("2tIxk"),
    $a84d07efd5d6386a$var$load("dLq4a"),
    $a84d07efd5d6386a$var$load("27glK"),
    $a84d07efd5d6386a$var$load("bvY53"),
    $a84d07efd5d6386a$var$load("lTK3c"),
    $a84d07efd5d6386a$var$load("1WXdc"),
    $a84d07efd5d6386a$var$load("3GuOt"),
    $a84d07efd5d6386a$var$load("hUmZG"),
    $a84d07efd5d6386a$var$load("h4Nf7"),
    $a84d07efd5d6386a$var$load("5o4Kn"),
    $a84d07efd5d6386a$var$load("6rS39"),
    $a84d07efd5d6386a$var$load("3MYQs"),
    $a84d07efd5d6386a$var$load("6SWFK"),
    $a84d07efd5d6386a$var$load("5zapo"),
    $a84d07efd5d6386a$var$load("6wr18"),
    $a84d07efd5d6386a$var$load("9atVd"),
    $a84d07efd5d6386a$var$load("ffEVr"),
    $a84d07efd5d6386a$var$load("Y76xf"),
    $a84d07efd5d6386a$var$load("jbM5v"),
    $a84d07efd5d6386a$var$load("219St"),
    $a84d07efd5d6386a$var$load("b1DMS"),
    $a84d07efd5d6386a$var$load("lVrrs"),
    $a84d07efd5d6386a$var$load("3NkiL"),
    $a84d07efd5d6386a$var$load("aqfyB"),
    $a84d07efd5d6386a$var$load("fCxvi"),
    $a84d07efd5d6386a$var$load("1bbSu"),
    $a84d07efd5d6386a$var$load("kbwlB"),
    $a84d07efd5d6386a$var$load("Wowvf"),
    $a84d07efd5d6386a$var$load("cRtGo"),
    $a84d07efd5d6386a$var$load("s4822"),
    $a84d07efd5d6386a$var$load("hhss7"),
    $a84d07efd5d6386a$var$load("2OkLl"),
    $a84d07efd5d6386a$var$load("lnKog"),
    $a84d07efd5d6386a$var$load("h3ABO"),
    $a84d07efd5d6386a$var$load("kC80R"),
    $a84d07efd5d6386a$var$load("7EorR"),
    $a84d07efd5d6386a$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("gICEw", function(module, exports) {

let $c2bebd00094ed995$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2bebd00094ed995$var$load("2YffH"),
    $c2bebd00094ed995$var$load("jjZO0"),
    $c2bebd00094ed995$var$load("AGwzU"),
    $c2bebd00094ed995$var$load("bUxH9"),
    $c2bebd00094ed995$var$load("eBRUf"),
    $c2bebd00094ed995$var$load("i6XKW"),
    $c2bebd00094ed995$var$load("1BN67"),
    $c2bebd00094ed995$var$load("2tIxk"),
    $c2bebd00094ed995$var$load("dLq4a"),
    $c2bebd00094ed995$var$load("27glK"),
    $c2bebd00094ed995$var$load("bvY53"),
    $c2bebd00094ed995$var$load("lTK3c"),
    $c2bebd00094ed995$var$load("1WXdc"),
    $c2bebd00094ed995$var$load("3GuOt"),
    $c2bebd00094ed995$var$load("hUmZG"),
    $c2bebd00094ed995$var$load("h4Nf7"),
    $c2bebd00094ed995$var$load("5o4Kn"),
    $c2bebd00094ed995$var$load("6rS39"),
    $c2bebd00094ed995$var$load("3MYQs"),
    $c2bebd00094ed995$var$load("6SWFK"),
    $c2bebd00094ed995$var$load("5zapo"),
    $c2bebd00094ed995$var$load("6wr18"),
    $c2bebd00094ed995$var$load("9atVd"),
    $c2bebd00094ed995$var$load("ffEVr"),
    $c2bebd00094ed995$var$load("Y76xf"),
    $c2bebd00094ed995$var$load("jbM5v"),
    $c2bebd00094ed995$var$load("219St"),
    $c2bebd00094ed995$var$load("b1DMS"),
    $c2bebd00094ed995$var$load("lVrrs"),
    $c2bebd00094ed995$var$load("3NkiL"),
    $c2bebd00094ed995$var$load("aqfyB"),
    $c2bebd00094ed995$var$load("fCxvi"),
    $c2bebd00094ed995$var$load("1bbSu"),
    $c2bebd00094ed995$var$load("kbwlB"),
    $c2bebd00094ed995$var$load("Wowvf"),
    $c2bebd00094ed995$var$load("cRtGo"),
    $c2bebd00094ed995$var$load("s4822"),
    $c2bebd00094ed995$var$load("hhss7"),
    $c2bebd00094ed995$var$load("2OkLl"),
    $c2bebd00094ed995$var$load("lnKog"),
    $c2bebd00094ed995$var$load("h3ABO"),
    $c2bebd00094ed995$var$load("kC80R"),
    $c2bebd00094ed995$var$load("7EorR"),
    $c2bebd00094ed995$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("gektR", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const handleError = (0, $42omo.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "@confluence/content-topper"
    });
    const isTitleAlignmentLoading = networkStatus === (0, $5T18X.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $5T18X.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $42omo.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $42omo.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                __callerPackage__: "@confluence/content-topper"
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: data,
                                __callerPackage__: "@confluence/content-topper"
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        data,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});

parcelRegister("80koo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $42omo.useState)({
        loaded: false,
        modules: []
    });
    (0, $42omo.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};
module.exports["RequireLegacyWRM"] = $c65634971abef8c1$export$c2019f6d43c6c1ce;

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});


//# sourceMappingURL=EditorByLineArea.50b96d78.js.map
